import React from 'react';
import classNames from 'classnames';

import Icon from '../../../Icon/Icon';

interface NumberBallProps {
  type: 'star' | 'ball' | 'bonus',
  /** Usually is a char that comes from backend */
  color: string,
  value: number,
  isActive: boolean,
  className?: string,
  /** If banker the color changes */
  isBanker?: boolean,
  bankers: boolean,
  onClick?: Function,
  sameBallset?: boolean,
  alreadySelected?: boolean
}

export default function Number({ type,
  color,
  value,
  isActive,
  isBanker,
  onClick,
  bankers,
  className='number-picker',
  sameBallset=true,
  alreadySelected=false
}: NumberBallProps) {

  let typeOfBall = type;
  if (type === 'bonus' && sameBallset){
    typeOfBall = 'ball';
  } else if (type=== 'bonus' && !sameBallset){
    typeOfBall = 'star';
  }

  return (
    <>
      <button
        className={
          classNames({
            [`${ className }__ball`]: typeOfBall==='ball',
            [`${ className }__star`]: typeOfBall==='star',
            [`${ className }__ball--bankers`]: bankers,
            [`${ className }__ball--${ color }`]: color && typeOfBall === 'ball',
            [`${ className }__${ typeOfBall }--selected`]: isActive,
            [`${ className }__${ typeOfBall }--pre-selected`]: alreadySelected,
            [`${ className }__${ typeOfBall }--banker`]: !isActive && isBanker // Bankers have a type because in the future Bonus markets should have bankers too.
          })
        }
        onClick={ onClick ? onClick(value, type) : () => {} }
      >
        {
          typeOfBall === 'ball' ?  value  : (
            <>
              <div className={ `${ className }__star-value` }>{ value }</div>
              <Icon icon="star" />
            </>
          )
        }
      </button>
    </>
  );
}
